import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import {
  FormHelperText,
  ListItemIcon,
  Typography,
  alpha,
  useTheme,
} from "@mui/material";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import React from "react";
import InfoCircle from "../../../media/images/icons/info-circle";

interface IOption {
  label: string;
  value: number;
  disabled?: boolean;
}

interface SelectProps {
  type: string;
  value?: string;
  setValue: (selected: string, type: string) => void;
  options?: IOption[];
  disabled?: boolean;
  width?: string;
  height?: string;
  loading?: boolean;
  borderColor?: string;
  borderRadius?: string;
  textColor?: string;
  fontSize?: string;
  innerIcon?: JSX.Element;
  error?: boolean;
  errorMessage?: any;
}

const CustomSelect = (props: SelectProps) => {
  const theme = useTheme();
  const {
    type,
    value = "",
    setValue,
    width = "100%",
    height = "48px",
    // disabled,
    // loading,
    textColor = "textColor.main",
    borderColor = "primary.main",
    borderRadius = "10px",
    options = [],
    fontSize = "12px",
    innerIcon,
    error,
    errorMessage,
  } = props;

  const handleChange = (event: SelectChangeEvent<string>) => {
    const selectedValue = event.target.value;
    const option = options.find((opt) => {
      // console.log(opt.value, "=====", Number(selectedValue));
      return opt.value === Number(selectedValue);
    });

    if (option) {
      setValue(String(option.value), type);
    }
  };
  return (
    <>
      <style>{`
        .MuiMenu-list {
        color: ${theme.palette.textColor.main}
        height:30px;
        }
        .MuiMenu-paper {
        direction: rtl;
        box-shadow: 0px 4px 15px 0px ${alpha(
          theme.palette.textColor.main,
          0.2
        )};
        border-radius:2px 2px 12px 12px;
        border: 1px solid ${theme.palette.textColor.light};
        border-top: 0
        }
        .MuiMenuItem-root {
        min-height:40px;
        }
       .MuiPopover-root .MuiPaper-root {
                  max-height:200px;

                  }
      `}</style>
      <Box
        sx={{
          width: width,

          "& .MuiInputBase-root": {
            height: height,
            borderRadius: borderRadius,
            boxShadow: "0px 2px 15px 0px rgba(0, 0, 0, 0.06)",
            // borderColor: ,
            "&.Mui-focused fieldset": {
              borderColor: borderColor,
            },
            "&:hover fieldset": {
              borderColor: borderColor,
            },
          },
          "& .MuiInputBase-input": {
            pl: "32px",
            pr: "8px !IMPORTANT",
            fontSize: fontSize,
          },

          "& fieldset": {
            borderColor: theme.palette.textColor.light,
            // border: "1.5px solid",
          },

          "& svg": {
            left: 7,
            right: "auto",
            fontSize: "22px",
            color: theme.palette.textColor.light,
          },
        }}
      >
        <FormControl fullWidth>
          <Select
            className="selectDate"
            placeholder={"فرستنده را انتخاب کنید*"}
            error={error}
            sx={{
              color: textColor,
              "& .MuiPaper-root": {
                maxHeight: "200px",
              },
            }}
            value={value}
            onChange={handleChange}
            IconComponent={ExpandMoreRoundedIcon}
            renderValue={(value) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                {innerIcon}
                <Typography
                  sx={{
                    fontSize: "14px",
                  }}
                >
                  {
                    options.filter((item) => item.value === Number(value))[0]
                      .label
                  }
                </Typography>
              </div>
            )}
          >
            {options.map((row, i) => (
              <MenuItem
                disabled={row.disabled}
                sx={{
                  fontSize: "14px",
                }}
                key={i}
                value={row.value}
              >
                {row.label}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText
            style={{
              padding: "0px",
              marginTop: "4px",
              color: "red",
              direction: "rtl",
              textAlign: "right",
              fontSize: 13,
            }}
          >
            {errorMessage}
          </FormHelperText>
        </FormControl>
      </Box>
    </>
  );
};
export default CustomSelect;
